import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule, MatTooltipModule } from '@angular/material';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { PalantirContentModule } from '../palantir-content/palantir-content.module';
import { PalantirTagModule } from '../palantir-tag/palantir-tag.module';
import { PalantirTextModule } from '../palantir-text/palantir-text.module';
import { TagListDialogComponent } from './tag-list-dialog.component';

@NgModule({
  declarations: [TagListDialogComponent],
  imports: [
    CommonModule,
    PipesModule,
    PalantirTextModule,
    PalantirContentModule,
    TranslateModule,
    MatTooltipModule,
    PalantirTagModule
  ],
  exports: [TagListDialogComponent]
})
export class TagListDialogModule { }
